import { client } from '../client';
import { getData } from '../apiUtils';
import { Endpoints } from '../endpoints';

export type WhatsNew = {
  tag: string;
  description: string;
};

export const createWhatsNew = async (whatsNew: FormData) => (
  client.post(Endpoints.whatsNew, whatsNew, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(getData)
);

export const updateWhatsNew = async (id: string, whatsNew: FormData) => (
  client.put(`${Endpoints.whatsNew}/${id}`, whatsNew, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(getData)
);

export const getAllWhatsNew = async (clientId?: string | null) => client.get(`${Endpoints.whatsNew}${clientId ? `?clientId=${clientId}` : ''}`).then(getData);

export const getWhatsNewById = async (id: string) => client.get(`${Endpoints.whatsNew}/${id}`).then(getData);

export const deleteWhatsNew = async (id: string) => client.delete(`${Endpoints.whatsNew}/${id}`).then(getData);

export const togglePublishStatus = async (id: string, isPublish: boolean) => client.put(`${Endpoints.whatsNew}/${id}/publish`, { isPublish }).then(getData);

export const emailSent = async (data: { popupId: string, clientId: string | null, popupdetails: { heading: string, shortDescription: string }[] }) => client.post(`${Endpoints.whatsNew}/send-mail`, data).then(getData);
